<h3 mat-dialog-title>
  {{ dialogTitle }}
</h3>
<mat-dialog-content>
  <div class="subtitle-help-text mb-4" *ngIf="assignedBookingItemNameList.length > 0">
    <p>
      <strong i18n>This workflow is assigned to the following options:</strong>
    </p>
    <ul class="list-unstyled list-inline">
      <li *ngFor="let assignedBookingItemName of assignedBookingItemNameList; last as isLast">
        {{ assignedBookingItemName }}<span *ngIf="!isLast">,</span>
      </li>
    </ul>
  </div>
  <eas-workflow-editor></eas-workflow-editor>
</mat-dialog-content>
<mat-dialog-actions>
  <button *ngIf="data.action === 'edit'"
          mat-flat-button
          color="warn"
          (click)="onDelete()"
          i18n>Delete</button>
  <div>
    <button mat-button (click)="onCancel()" i18n>Discard changes</button>
    <button mat-flat-button
            (click)="onSubmit()"
            color="primary"
            [disabled]="!canSubmit()"
            i18n>Apply workflow</button>
  </div>
</mat-dialog-actions>
